import { styled } from "@mui/system";
import ColourConstants from "helpers/colourConstants";
import Typography from "@mui/material/Typography";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import DialogContent from "@mui/material/DialogContent";
import TextField from "@mui/material/TextField";

const AddDialogStyle = () => {
	const media = "@media (max-width: 414px)";
	const mediumScreen = "@media (max-width: 768px)";
	const smallScreen = "@media (max-width: 654px)";

	return {
		ActionContainer: styled("div")({
			display: "inline-flex",
			[media]: {
				flexWrap: "wrap",
			},
		}),
		//for file upload encoding notes only -- upload-csv-file
		ActionContainerFileUpload: styled("div")({
			display: "flex",
			alignItems: "start",
			justifyContent: "flex-start",
			[smallScreen]: {
				flexWrap: "wrap",
			},
		}), //for file upload encoding notes only -- upload-csv-file
		NoteText: styled(Typography)({
			marginRight: "auto",
			fontFamily: "Roboto Condensed",
			fontWeight: "bold",
			fontSize: 14,
			color: ColourConstants.commonNoteText,
			[smallScreen]: {
				fontSize: 12,
				textWrap: "wrap",
			},
		}),
		//for file upload encoding notes only -- upload-csv-file
		NoteButtonContainer: styled(DialogActions)({
			marginLeft: "auto",
			[smallScreen]: {
				marginLeft: "18px",
			},
		}),
		HeaderText: styled(Typography)({
			marginRight: "auto",
			fontFamily: "Roboto Condensed",
			fontWeight: "bold",
			fontSize: 21,
			color: ColourConstants.commonText,
			[media]: {
				fontSize: 18,
			},
		}),
		ButtonContainer: styled(DialogActions)({
			marginLeft: "auto",
			[media]: {
				marginLeft: "18px",
			},
		}),
		CancelButton: styled(Button)({
			height: 43,
			width: 160,
			fontSize: 15,
			backgroundColor: ColourConstants.cancelButton,
			color: "#FFFFFF",
			fontFamily: "Roboto Condensed",
			[media]: {
				width: "100px",
			},
			"&.MuiButton-root:hover": {
				backgroundColor: "#d5d5d5",
			},
		}),
		ConfirmButton: styled(Button)({
			lineHeight: "18px",
			height: 43,
			width: 160,
			fontSize: 15,
			backgroundColor: ColourConstants.confirmButton,
			color: "#FFFFFF",
			fontFamily: "Roboto Condensed",
			[media]: {
				width: "100px",
			},
			"&.MuiButton-root:hover": {
				backgroundColor: "#d5d5d5",
			},
		}),
		DialogContent: styled(DialogContent)({
			marginBottom: 15,
		}),
		InputContainer: styled("div")({
			width: "100%",
			display: "flex",
			marginBottom: 20,
			[media]: {
				flexDirection: "column",
			},
			[mediumScreen]: {
				flexDirection: "column",
			},
		}),
		NameInputContainer: styled("div")({
			width: "50%",
			[media]: {
				width: "100%",
			},
		}),
		FieldInputContainer: styled("div")({
			width: "50%",
			paddingRight: 15,
		}),
		InfoText: styled(Typography)({
			marginTop: 10,
			marginBottom: 10,
			fontFamily: "Roboto",
			color: ColourConstants.commonText,
			fontSize: 15,
		}),
		InputLabel: styled(Typography)({
			fontFamily: "Roboto Condensed",
			fontSize: 14,
			fontWeight: "bold",
			color: ColourConstants.commonText,
			paddingBottom: 5,
			width: "100%",
		}),
		LeftInputContainer: styled("div")({
			paddingRight: 15,
			width: "50%",
			[media]: {
				width: "100%",
				paddingRight: 0,
				marginBottom: "20px",
			},
		}),
		FullWidthContainer: styled("div")({
			width: "100%",
			paddingRight: 15,
			[media]: {
				width: "100%",
				paddingRight: 0,
				marginBottom: "20px",
			},
		}),
		NameLabel: styled(Typography)({
			fontFamily: "Roboto Condensed",
			fontSize: 14,
			fontWeight: "bold",
			color: ColourConstants.commonText,
			paddingBottom: 5,
			width: "100%",
		}),
		RequiredStar: styled("span")({
			color: ColourConstants.requiredStar,
		}),
		RightInputContainer: styled("div")({
			paddingLeft: 15,
			width: "50%",
			[media]: {
				paddingLeft: 0,
				width: "100%",
			},
		}),
		NameInput: styled(TextField)({
			width: "100%",
		}),
		CheckboxContainer: styled("div")({
			width: "50%",
			paddingLeft: "7%",
			paddingTop: 17,
			[media]: {
				width: "100%",
				paddingLeft: "0px",
			},
		}),
		CheckboxLabel: styled(Typography)({
			fontFamily: "Roboto",
			fontSize: 14,
			color: ColourConstants.commonText,
		}),
	};
};

export default AddDialogStyle;
